export default {
  isAuthenticated: (state) => state.token !== null,
};
